<template>
  <!-- Holter機器準備 -->
  <div id="HolterDevicePreparation">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterDevicePreparation"'></holterNavi>
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 機器準備</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.requestDateStart"/> ～ <input type="date" v-model="searchConditions.requestDateEnd"/></td>
            <th>出荷日</th>
            <td colspan="3"><input type="date" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" v-model="searchConditions.shippingDateEnd"/></td>
          </tr>
          <tr>
            <th>受付番号</th>
            <td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>配送先</th>
            <td><select v-model="searchConditions.shippingType"><option></option><option value="0">個人宅</option><option value="1">医療機関</option></select></td>
            <th>機種</th>
            <td><select v-model="searchConditions.model"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            <template v-if="!atLaunchHidden.hiddenFlag">
              <th>リードワイヤーアダプター</th>
              <td>
                <select v-model="searchConditions.leadWireAdapter">
                <option></option>
                <option value="0">必要</option>
                <option value="1">不要</option>
                </select>
              </td>
            </template>
            <template v-else>
              <th class="sp-hidden"></th>
              <td class="sp-hidden"></td>
            </template>
          </tr>
          <tr>
            <th>医療機関</th>
            <td><input type="text" v-model="searchConditions.hospital"/></td>
            <th>患者名</th>
            <td><input type="text" v-model="searchConditions.patientName"/></td>
            <th>配達希望時間</th>
            <td><select v-model="searchConditions.desiredDeliveryTimeZone"><option v-for="timeZone in desiredDeliveryTimeZoneList" :value="timeZone.value" :key="timeZone.value">{{ timeZone.label1 }}</option></select></td>
            <template v-if="!atLaunchHidden.hiddenFlag">
            </template>
            <template v-else>
              <th v-if="atLaunchHidden.hiddenFlag" class="sp-hidden"></th>
              <td v-if="atLaunchHidden.hiddenFlag" class="sp-hidden"></td>
            </template>
          </tr>
          <tr>
            <th>検査期間</th>
              <td>
                <select v-model="searchConditions.inspectionPeriod">
                  <option></option>
                  <option value="1">5日</option>
                  <option value="5">7日</option>
                  <option value="3">10日</option>
                  <option value="4">14日</option>
                </select>
              </td>
            <th>備考</th>
            <td><input type="text" v-model="searchConditions.note"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult">
        <div class="result-sub-area">
          <span class="result-count">件数：{{data.length}}件</span>
          <div class="operation-area">
            <b-button class="operationButton is-primary" icon-left="stamper" @click="receptionist" :disabled="isButtonDisable">機器予約</b-button>
          </div>
        </div>
        <b-table
            id="holterDevicePreparationTable"
            :data="data">
            <template slot-scope="props">
              <b-table-column label="#" width="50" centered>{{props.index +1}}</b-table-column>
              <b-table-column field="hstRequestFlag" label="WP300同梱の有無" width="90" sortable centered>
                <span v-if="props.row.hstRequestFlag">有</span><span v-else>無</span>
              </b-table-column>
              <b-table-column field="kind" label="機器シリアル" width="80" centered sortable>
                <input type="text" :id="'serial' + props.index" v-model="props.row.serial" @keyup.enter="onKeyupEnter(props.row, props.index)" @blur="focusLost(props.row)" @focus="isButtonDisable=true" @input="isButtonDisable=true"/>
              </b-table-column>
              <b-table-column field="pach-lot1" label="パッチのロット1" width="80" centered sortable>
                <input type="text" :id="'patchlot1' + props.index" v-model="props.row.patchlot1" @keyup.enter="onKeyupEnterPatchlot1(props.row, props.index)" @blur="isButtonDisable=false" @focus="isButtonDisable=true" @input="isButtonDisable=true"/>
              </b-table-column>
              <b-table-column field="pach-lot2" label="パッチのロット2" width="80" centered sortable>
                <input type="text" :id="'patchlot2' + props.index" v-model="props.row.patchlot2" @keyup.enter="onKeyupEnterPatchlot2(props.row, props.index)" @blur="isButtonDisable=false" @focus="isButtonDisable=true" @input="isButtonDisable=true" :disabled="props.row.inspectionPeriod=='1'||props.row.inspectionPeriod=='2'"/>
              </b-table-column>
              <b-table-column field="pach-lot3" label="パッチのロット3" width="80" centered sortable>
                <input type="text" :id="'patchlot3' + props.index" v-model="props.row.patchlot3" @keyup.enter="onKeyupEnterPatchlot3(props.row, props.index)" @blur="isButtonDisable=false" @focus="isButtonDisable=true" @input="isButtonDisable=true" :disabled="props.row.inspectionPeriod=='1'||props.row.inspectionPeriod=='2'||props.row.inspectionPeriod=='3'||props.row.inspectionPeriod=='5'"/>
              </b-table-column>
              <b-table-column v-if="!atLaunchHidden.hiddenFlag" field="leadWireAdapter" label="リードワイヤーアダプター" width="100" centered sortable>
                <input v-if="props.row.delivaryTarget == 'hospital' && props.row.leadWireAdapter == true" type="text" :id="'leadPatch' + props.index" v-model="props.row.leadPatch" @keyup.enter="onKeyupEnterLeadPatch(props.row, props.index)" @blur="isButtonDisable=false" @focus="isButtonDisable=true" @input="isButtonDisable=true"/>
                <input v-else type="text" :id="'leadPatch' + props.index" disabled/>
              </b-table-column>
              <b-table-column field="leaseupDate" label="リースアップ日" width="100" centered sortable>
                {{props.row.leaseupDate}}
              </b-table-column>
              <b-table-column field="reserveTime" label="機器予約コード" width="100" centered sortable>
                {{props.row.reserveTime}}
              </b-table-column>
              <b-table-column field="requestDate" label="受付日" width="100" sortable centered>
                {{props.row.requestDate}}
              </b-table-column>
              <b-table-column field="receiptNumber" label="受付番号" width="100" sortable centered>
                <router-link :to="{name:'HolterDevicePreparationDetail', params:{receiptNumber:props.row.receiptNumber,searchConditions:searchConditions,holterJudgmentFlg:props.row.holterJudgmentFlg}}"><a>{{props.row.receiptNumber}}</a></router-link>
                <br><span v-if="props.row.depo" class="depo"/>
              </b-table-column>
              <b-table-column field="shippingDate" label="出荷日" width="100" sortable centered>
                {{props.row.shippingDate}}
              </b-table-column>
              <b-table-column field="shippingAddress" label="配送先" width="100" sortable >
                {{props.row.shippingAddress}}
              </b-table-column>
              <b-table-column field="instrumentKind" label="機種" width="80" sortable >
                {{props.row.instrumentKind}}
              </b-table-column>
              <b-table-column field="inspectionPeriod" label="検査期間" width="80" sortable centered>
                <span v-if="!props.row.holterJudgmentFlg && (props.row.inspectionPeriod=='1' || props.row.inspectionPeriod=='2')">5日</span>
                <span v-if="!props.row.holterJudgmentFlg && props.row.inspectionPeriod=='3'">10日</span>
                <span v-if="!props.row.holterJudgmentFlg && props.row.inspectionPeriod=='4'">14日</span>
                <span v-if="!props.row.holterJudgmentFlg && props.row.inspectionPeriod=='5'">7日</span>
                <span v-if="props.row.holterJudgmentFlg && props.row.inspectionPeriod=='2'">5日（判定医付き）</span>
                <span v-if="props.row.holterJudgmentFlg && props.row.inspectionPeriod=='3'">10日（判定医付き）</span>
                <span v-if="props.row.holterJudgmentFlg && props.row.inspectionPeriod=='4'">14日（判定医付き）</span>
                <span v-if="props.row.holterJudgmentFlg && props.row.inspectionPeriod=='5'">7日（判定医付き）</span>
              </b-table-column>
              <b-table-column v-if="!atLaunchHidden.hiddenFlag" field="leadWireAdapter-2" label="リードワイヤーアダプターの有無" width="180" sortable centered>
                <span v-if="props.row.leadWireAdapter == true">必要</span>
                <span v-else>不要</span>
              </b-table-column>
              <b-table-column field="hospital" label="医療機関" width="150" sortable >
                {{props.row.hospital}}
              </b-table-column>
              <b-table-column field="patientName" label="患者名" width="120" sortable >
                {{props.row.patientName}}
              </b-table-column>
              <b-table-column field="desiredDeliveryTimeZone" label="配達希望時間" width="120" sortable centered>
                {{props.row.desiredDeliveryTimeZone }}
              </b-table-column>
              <b-table-column field="note" label="備考" width="250" sortable>
                {{props.row.note }}
              </b-table-column>
            </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holter/HolterNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
export default {
  name: "HolterDevicePreparation",
  methods: {
    doSearch: function(){
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterDevicePreparationListPOST;
      var successCallBack = this.getHolterDevicePreparationListPOSTSuccess;
      var errorCallBack = this.getHolterDevicePreparationListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);

    },
    getHolterDevicePreparationListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      return client.apis.internalHolter.getHolterDevicePreparationListPOST({
        body:obj
      });
    },
    getHolterDevicePreparationListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getHolterDevicePreparationListPOSTError: function(result) {
      // 検索結果取得
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    onKeyupEnter: function(rowItem, index){
      if(!rowItem.serial){
        return
      }
      //シリアルを取得
      let serialItems = rowItem.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.serial = serialItems[1]
      }
      if(rowItem.serial){
        var cnt = index + 1
        var nextElement = null
        while(cnt < this.data.length && !nextElement){
          nextElement = document.getElementById("serial" + (cnt));
          if(nextElement.disabled){
            nextElement = null
            cnt++
          }
        }
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("serial" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterPatchlot1: function(rowItem, index){
      if(!rowItem.patchlot1){
        return
      }
      //パッチのロット1を取得
      let patchlot1Items = rowItem.patchlot1.split('/');
      if(patchlot1Items.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.patchlot1 = patchlot1Items[1]
      }
      if(rowItem.patchlot1){
        var cnt = index + 1
        var nextElement = null
        while(cnt < this.data.length && !nextElement){
          nextElement = document.getElementById("patchlot1" + (cnt));
          if(nextElement.disabled){
            nextElement = null
            cnt++
          }
        }
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("patchlot1" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterPatchlot2: function(rowItem, index){
      if(!rowItem.patchlot2){
        return
      }
      //パッチのロット2を取得
      let patchlot2Items = rowItem.patchlot2.split('/');
      if(patchlot2Items.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.patchlot2 = patchlot2Items[1]
      }
      if(rowItem.patchlot2){
        var cnt = index + 1
        var nextElement = null
        while(cnt < this.data.length && !nextElement){
          nextElement = document.getElementById("patchlot2" + (cnt));
          if(nextElement.disabled){
            nextElement = null
            cnt++
          }
        }
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("patchlot2" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterPatchlot3: function(rowItem, index){
      if(!rowItem.patchlot3){
        return
      }
      //パッチのロット3を取得
      let patchlot3Items = rowItem.patchlot3.split('/');
      if(patchlot3Items.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.patchlot3 = patchlot3Items[1]
      }
      if(rowItem.patchlot3){
        var cnt = index + 1
        var nextElement = null
        while(cnt < this.data.length && !nextElement){
          nextElement = document.getElementById("patchlot3" + (cnt));
          if(nextElement.disabled){
            nextElement = null
            cnt++
          }
        }
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("patchlot3" + (index));
          element.blur();
        }
      }
    },
    onKeyupEnterLeadPatch: function(rowItem, index){
      if(!rowItem.leadPatch){
        return
      }
      //リードパッチを取得
      let leadPatchItems = rowItem.leadPatch.split('/');
      if(leadPatchItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        rowItem.leadPatch = leadPatchItems[1]
      }
      if(rowItem.leadPatch){
        var cnt = index + 1
        var nextElement = null
        while(cnt < this.data.length && !nextElement){
          nextElement = document.getElementById("leadPatch" + (cnt));
          if(nextElement.disabled){
            nextElement = null
            cnt++
          }
        }
        if(nextElement){
          // 次のアイテムが存在する場合、フォーカスを移動
          this.focusTarget = nextElement
          nextElement.focus();
        }else{
          // 次のアイテムが存在しない場合、フォーカスを外す
          let element = document.getElementById("leadPatch" + (index));
          element.blur();
        }
      }
    },
    focusLost: async function (rowItem) {
      this.searchTarget = rowItem
      if(rowItem.serial){
        var excuteApi = this.getMachineDetailPOST;
        var successCallBack = this.getMachineDetailPOSTSuccess;
        var errorCallBack = this.getMachineDetailPOSTError;
        // WebAPI Call
        await this.apiCall(excuteApi, successCallBack, errorCallBack);
      }else{
        this.isButtonDisable = false
        this.$set(this.searchTarget,"leaseupDate","")
        this.$set(this.searchTarget,"reserveTime","")
      }
    },
    getMachineDetailPOST: function(client) {
      return client.apis.apiCommon.getMachineDetailPOST({ 
        body: {
          serial:this.searchTarget.serial,
          modelId:this.searchTarget.modelId
        } 
      });
    },
    getMachineDetailPOSTSuccess: function(result) {
      var machineDetail = result.obj;
      if(this.isPastday(machineDetail.leaseupDate)){
        // リースアップ日を超えている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップ日を超過している機器です。";
        this.$dialog.alert({
          title: '　',
          message: messsge
        })
        this.$set(this.searchTarget,"serial","")
      }else if(this.isSoon(machineDetail.leaseupDate,2)){
        // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
        var messsge = machineDetail.leaseupDate + "にリースアップする機器です。";
        let _this = this;
        this.$dialog.alert({
          title: '　',
          message: messsge,
          onConfirm: () => {
            if(_this.focusTarget){
              _this.focusTarget.focus();
              _this.focusTarget = null
            }
          }
        })
        this.$set(this.searchTarget,"serial","")
      }else{
        // リースアップ日をセット
        this.$set(this.searchTarget,"leaseupDate",machineDetail.leaseupDate)
        // 機器予約コードをセット
        this.$set(this.searchTarget,"reserveTime",new Date().getTime())
      }
      this.isButtonDisable = false
    },
    getMachineDetailPOSTError: function(result) {
      // シリアルに一致する利用可能な機器が存在しない場合
      this.$set(this.searchTarget,"serial","")
      this.$set(this.searchTarget,"leaseupDate","")
      this.$set(this.searchTarget,"reserveTime","")
      this.showErrorMessage(result);
      this.isButtonDisable = false;
    },
    isDuplicateSerial: function() {
      // シリアルの重複チェック
      const serialList = []
      this.data.map((item) =>{
        if(item.serial){
          serialList.push(item.serial)
        }
      });
      const setElements = new Set(serialList);
      if (setElements.size !== serialList.length) {
        return true
      }
      return false
    },
    receptionist: function() {
      if(this.isDuplicateSerial()){
        this.showErrorMessage("重複しているシリアル番号があります。")
        return
      }
      var check1_data = this.data.filter(val => val.serial && val.reserveTime);
      var check2_data = this.data.filter(val => val.patchlot1);
      if(check1_data.length > check2_data.length){
        this.showErrorMessage("パッチ1が入力されていません。")
        return
      }
      if(check1_data.length < check2_data.length){
        this.showErrorMessage("正しいシリアル番号が入力されていません。")
        return
      }
      this.receptionistData = this.data.filter(val => val.serial && val.patchlot1 && val.reserveTime);
      if(this.receptionistData.length==0){
        this.showErrorMessage("正しいシリアル番号が入力されていません。")
        return
      }
      for(let i = 0; i < this.receptionistData.length; i++) {
        if((this.receptionistData[i].inspectionPeriod == '3' || this.receptionistData[i].inspectionPeriod == '4') && !this.receptionistData[i].patchlot2){
          this.showErrorMessage("パッチ2が入力されていません。")
          return
        }
      }
      for(let i = 0; i < this.receptionistData.length; i++) {
        if(this.receptionistData[i].inspectionPeriod == '4' && !this.receptionistData[i].patchlot3){
          this.showErrorMessage("パッチ3が入力されていません。")
          return
        }
      }
      if(check1_data.length == check2_data.length){
        // 機器予約
        var excuteApi = this.setHolterDeviceReservePOST;
        var successCallBack = this.setHolterDeviceReservePOSTSuccess;
        var errorCallBack = this.setHolterDeviceReservePOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      }
    },
    setHolterDeviceReservePOST: function(client) {
      return client.apis.internalHolter.setHolterDeviceReservePOST({
        body:this.receptionistData
      });
    },
    setHolterDeviceReservePOSTSuccess: function(result) {
      this.showSuccess(result,this.doSearch());
    },
    setHolterDeviceReservePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getChoicesList: async function() {
      this.modelList =  this.getChoiceList(this.choicesType.holterKind, false);
      this.desiredDeliveryTimeZoneList =  this.getChoiceList(this.choicesType.deliveryTime, false);
      this.cannulaSizeList =  this.getChoiceList(this.choicesType.cannulaSize, false);
      this.beltSizeList =  this.getChoiceList(this.choicesType.beltSize, false);
      this.modelList.unshift({})
      this.desiredDeliveryTimeZoneList.unshift({})
      this.cannulaSizeList.unshift({})
      this.beltSizeList.unshift({})
    },
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    return {
      searchConditions:{
        requestDateStart:"",
        requestDateEnd:"",
        shippingDateStart:"",
        shippingDateEnd:"",
        receiptNumber:"",
        shippingType:"",
        model:"",
        cannula:"",
        beltSize:"",
        hospital:"",
        patientName:"",
        desiredDeliveryTimeZone:"",
        note:""
      },
      choicesType:choicesType,
      data : [],
      hasResult: false,
      modelList:[],
      desiredDeliveryTimeZoneList:[],
      cannulaSizeList:[],
      beltSizeList:[],
      searchTarget:{},
      takeOverSearchParams,
      receptionistData:[],
      focusTarget:null,
      isButtonDisable:false,
      atLaunchHidden: atLaunchHidden
    };
  },
  async mounted() {
    // 機種マスタ取得
    await this.getChoicesList();
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {
    holterNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
.sp-hidden {
  empty-cells: hide;
  border: 0px;
  background: transparent;
}
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
#holterDevicePreparationTable input {
  width: 70px;
}
.result-count {
  white-space: nowrap; 
  width: 100px;
}
.result-sub-area {
  float: left;
  display: flex;
  flex-flow: column;
  margin-bottom: 10px;
}
.result-sub-area .operationButton {
  margin-top: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterDevicePreparation.vue